import { RunFieldsConfiguration } from "../../field-type";


export const zenotiFileRunFieldsConfiguration: RunFieldsConfiguration = {

    runCursor: {
        visible: false
    },
    file: {
        visible: true,
        mimeType: "text/csv"
    }

}